import { useDropzoneContext } from '../contexts/dropzone-context'
import { useFileUploadContext } from '../contexts/file-upload-context'

export function useGetFileUploadContext() {
  try {
    return useFileUploadContext()
  } catch (error) {
    return useDropzoneContext() /* eslint-disable-line react-hooks/rules-of-hooks */
  }
}
